import React, { FunctionComponent, useCallback, useState, useEffect } from 'react';
import { IInteriorColour } from '../../../../../../common/model/IColours';
import ScrollToWrapper from '../../presentational/ScrollToWrapper';
import { useDispatch, useSelector } from 'react-redux';
import { carConfigurationActions } from '../../../store/reducers/carConfigurationReducer';
import {
  getVariantDetailsCars,
  getVariantDetailsInteriors,
  getVariantDetailsLoadingState,
} from '../../../store/selectors/variantDetailsSelectors';
import carConfigurationSelectors from '../../../store/selectors/carConfigurationSelectors';
import CustomiseInterior from './customiseInterior/CustomiseInterior';
import optionsSelectors from '../../../store/selectors/optionsSelectors';
import usePlatformConfig from '../../../../common/react/usePlatformConfig';
import thunkActions from '../../../store/actions/thunkActions';
import configurationSourceUrlService from '../../../service/configurationSourceUrlService';
import { useParams } from 'react-router';
import useWidgetContext from '../../../../common/react/useWidgetContext';
import { customiseActions } from '../../../store/reducers/customiseReducer';
import { CustomiseSections } from '../../../../common/enum/CustomiseSections';
import IParams from '../../../../gqlCustomise/model/IParams';

const CustomiseInteriorContainer: FunctionComponent = () => {
  const [activeColor, setActiveColor] = useState(null);
  const [expanded, setExpanded] = useState(false);
  const dispatch = useDispatch();
  const optionsError = useSelector(optionsSelectors.getOptionsErrorState);
  const variantsLoading = useSelector(getVariantDetailsLoadingState);
  const variantDetailsCars = useSelector(getVariantDetailsCars);
  const selectedInteriorId: string = useSelector(carConfigurationSelectors.getSelectedInterior);
  const interiorColours = useSelector(getVariantDetailsInteriors);
  const {
    platformConfig: { priceDisplay },
  } = usePlatformConfig();
  const storeCustomisedCar = useSelector(carConfigurationSelectors.getCustomisedCar);
  const { modelId } = useParams<IParams>();
  const {
    configuration: { basePath },
  } = useWidgetContext();

  useEffect(() => {
    setActiveColor(selectedInteriorId);
  }, [selectedInteriorId]);

  const onClick = useCallback(
    async (id: string) => {
      setActiveColor(id);
      if (id && variantDetailsCars && interiorColours) {
        const currentSelected = interiorColours.find((color: IInteriorColour) => id === color.id);
        dispatch(
          carConfigurationActions.setInteriorColour({
            interior: currentSelected,
            variantDetailsCars,
          }),
        );
        const { payload } = (await dispatch(
          thunkActions.selectInterior({
            interior: currentSelected.id,
            configurationSourceUrl: configurationSourceUrlService.getUrl(
              basePath,
              modelId,
              variantDetailsCars[storeCustomisedCar.exterior.id][currentSelected.id],
              storeCustomisedCar,
            ),
            priceDisplay,
          }),
        )) as any;
        if (payload) {
          dispatch(customiseActions.setSelectedSection(CustomiseSections.INTERIOR));
          // @TODO: Refactor when deal decoupled from basket.
          dispatch(carConfigurationActions.setDataFromDeal(payload.deal));
        }
      }
    },
    [activeColor, variantDetailsCars, interiorColours, modelId, storeCustomisedCar, basePath],
  );

  return (
    <ScrollToWrapper target="interior">
      <CustomiseInterior
        loading={variantsLoading}
        error={optionsError}
        expanded={expanded}
        setExpanded={setExpanded}
        onClick={onClick}
        choices={interiorColours}
        activeChoice={selectedInteriorId}
      />
    </ScrollToWrapper>
  );
};

export default CustomiseInteriorContainer;
